import { render } from "./ArrowDown.vue?vue&type=template&id=bad73040"
const script = {}
script.render = render

export default script